import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestCasinoStart, requestCasinoEnd, requestLotusStart } from '../../store/casinoLive/casinoLive.thunks';

export const connectCasinoLive = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      casinoLive: state.casinoLive,
      user: state.auth,
      balance: state.balance,
      elementsParams: state.elementsParams,
      slotCasinoPopUp: state.slotCasinoPopUp
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestCasinoStart,
      requestCasinoEnd,
      requestLotusStart,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
